import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { supplierSelfRegister, uploadRegistrationDocs } from '../../registerApi';
import { useHistory } from 'react-router-dom';
import MediaSection from './mediaSection';
import FormInputs from './formInputs';
import { schema } from './schema';

import { useConfirmationModal } from '../../../../Redux/context/modalContext';
import {
  moengageTrackEvent,
  APIErrorTrackEvent,
} from '../../../../Analytics/moengageEventFunction';

const SupplierForm = () => {
  const history = useHistory();
  const [media, setMedia] = useState({});
  const [mediaArray, setMediaArray] = useState({});
  const [selectedCategory, setCategory] = useState(null);
  const [loader, setLoader] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });
  const { showModal, hideModal } = useConfirmationModal();

  const handleModalButtonClick = () => {
    hideModal();
    history.push(`/`);
  };

  const onSubmit = async (data) => {
    if (!selectedCategory) {
      alert('Please select atleast one category');
    } else if (!mediaArray?.panLink) {
      alert('Please Upload PAN Card');
    } else if (!mediaArray?.gstLink) {
      alert('Please Upload GST Certificate');
    } else if (!mediaArray?.cancelledChequeLink) {
      alert('Please Upload Cancelled Cheque');
    } else {
      setLoader(true);
      const formdata = {
        ...data,
        ...mediaArray,
        category: selectedCategory.value,
        isEnquiry: false,
      };
      let createVenResponse = await supplierSelfRegister(formdata);
      setLoader(false);
      if (createVenResponse && createVenResponse.data) {
        if (createVenResponse.data.status === 'success') {
          showModal({
            message: 'Our Team will reach out to you in next 24 hours',
            handleConfirm: handleModalButtonClick,
          });
          let { emailId, mobileNumber, pincode, ownerName, firmName, city, category } = formdata;
          let moePrams = { emailId, mobileNumber, pincode, ownerName, firmName, city, category };
          moengageTrackEvent('User_Registration_Self_Register_Submission', moePrams);
        } else {
          APIErrorTrackEvent({
            api: createVenResponse?.data?.config?.url,
            apiPayLoad: JSON.stringify(formdata),
            errorMsg: createVenResponse?.data?.msg,
          });
        }
      }
    }
  };

  const removeImage = (imgType) => {
    if (imgType) {
      setMedia({ ...media, [imgType]: null });
      setMediaArray({ ...mediaArray, [imgType]: null });
    }
  };

  const handleClick = (event) => {
    const { target = {} } = event || {};
    target.value = '';
  };

  const handleImage = (e, source) => {
    const { files } = e.target;
    if (files?.length > 0) {
      const formData = new FormData();
      formData.append('files', files[0]);
      uploadRegistrationDocs(formData)
        .then((res) => {
          if (res.data.status === 'success') {
            setMedia({
              ...media,
              [source]: URL.createObjectURL(files[0]),
              [source + 'Type']: files[0].type,
            });
            setMediaArray({ ...mediaArray, [source]: res.data.data });
          } else {
            alert(res.data.message);
          }
        })
        .catch((error) => {
          alert(error.response?.data?.message);
        });
    }
  };

  const handleCategory = (cat) => {
    setCategory(cat);
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormInputs
          errors={errors}
          handleCategory={handleCategory}
          register={register}
          selectedCategory={selectedCategory}
        />
        <MediaSection
          handleClick={handleClick}
          handleImage={handleImage}
          loader={loader}
          media={media}
          removeImage={removeImage}
        />
      </form>
    </>
  );
};
export default SupplierForm;
